import { useAuth } from '../context/AuthContext';
import { getPlan } from '../config/plans';

const usePlanFeatures = () => {
  const { user } = useAuth();
  const subscription = user?.subscription;

  const isTrial = !subscription || subscription.status === 'trialing';
  const effectivePlanId = isTrial ? 'pro' : (subscription.planId || 'pro');

  const plan = getPlan(effectivePlanId);
  const features = plan.features;

  const isFeatureAllowed = (featureKey) => {
    const val = features[featureKey];
    if (val === undefined) return true;
    return val !== false;
  };

  return {
    planId: effectivePlanId,
    features,
    isFeatureAllowed,
    maxStaff: features.maxStaff,
    smsMonthlyLimit: features.smsMonthlyLimit ?? 0,
    isTrial,
  };
};

export default usePlanFeatures;
